import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import problemEd from "@/assets/problem-ed.jpg";
import problemPe from "@/assets/problem-pe.jpg";
import problemAddiction from "@/assets/problem-addiction.jpg";
const problems = [
    {
        img: problemEd,
        label: "Erectile Dysfunction",
        heading: "Trouble getting or staying hard?",
        body: "When the mind is tense, the body follows. A consistent Rino practice rebuilds the neural pathways between your brain and your body, so you can achieve and maintain an erection naturally, even under pressure.",
        delay: "0s",
    },
    {
        img: problemPe,
        label: "Premature Ejaculation",
        heading: "Finishing too soon?",
        body: "Rino teaches you to feel and interpret the subtle cues your body sends as arousal builds. The greater your awareness of that arc, the more control you have over when and whether you choose to climax.",
        delay: "0.12s",
    },
    {
        img: problemAddiction,
        label: "Porn Dependence",
        heading: "Disconnected from real intimacy?",
        body: "Frequent pornography use can dull your brain's response to real-life pleasure. Rino replaces that habit with a practice that deepens your relationship with your own body and with your partner.",
        delay: "0.24s",
    },
];
const ProblemsSection = () => {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => { if (entry.isIntersecting) {
            setVisible(true);
            observer.disconnect();
        } }, { threshold: 0.1 });
        if (ref.current)
            observer.observe(ref.current);
        return () => observer.disconnect();
    }, []);
    return (_jsx("section", { id: "solutions", className: "py-24 md:py-32", children: _jsxs("div", { className: "container mx-auto px-6", children: [_jsxs("div", { className: "text-center mb-16", ref: ref, style: {
                        opacity: visible ? 1 : 0,
                        transform: visible ? "translateY(0)" : "translateY(20px)",
                        transition: "opacity 0.7s cubic-bezier(0.16,1,0.3,1), transform 0.7s cubic-bezier(0.16,1,0.3,1)",
                    }, children: [_jsx("p", { className: "uppercase tracking-[0.25em] text-sm font-semibold mb-5 text-brand-gradient", children: "What Rino Addresses" }), _jsxs("h2", { className: "font-serif text-foreground text-4xl md:text-5xl", children: ["Real problems, rooted", _jsx("br", {}), "in the mind"] })] }), _jsx("div", { className: "grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto", children: problems.map((p) => (_jsxs("div", { className: "bg-surface-raised border border-border rounded-2xl overflow-hidden", style: {
                            opacity: visible ? 1 : 0,
                            transform: visible ? "translateY(0)" : "translateY(28px)",
                            transition: `opacity 0.7s cubic-bezier(0.16,1,0.3,1) ${p.delay}, transform 0.7s cubic-bezier(0.16,1,0.3,1) ${p.delay}`,
                            boxShadow: "0 8px 32px hsl(20 10% 2% / 0.5)",
                        }, children: [_jsxs("div", { className: "relative h-52 overflow-hidden", children: [_jsx("img", { src: p.img, alt: p.label, className: "w-full h-full object-cover", loading: "lazy" }), _jsx("div", { className: "absolute inset-0", style: {
                                            background: "linear-gradient(to top, hsl(20 10% 8%) 0%, transparent 60%)",
                                        } }), _jsx("span", { className: "absolute bottom-4 left-5 text-primary text-xs uppercase tracking-widest font-semibold", children: p.label })] }), _jsxs("div", { className: "p-7", children: [_jsx("h3", { className: "font-serif text-foreground text-xl mb-3", children: p.heading }), _jsx("p", { className: "text-foreground/55 text-sm leading-relaxed", children: p.body })] })] }, p.label))) })] }) }));
};
export default ProblemsSection;
